
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/business-model",
      function () {
        return require("private-next-pages/download/business-model/index.tsx");
      }
    ]);
  